module.exports = __webpack_public_path__ + "media/images/bg-8e2ee63efaa3951d3227f0042def72e7.png";